import algoliasearch from 'algoliasearch/lite';
//dev
// export const searchClient = algoliasearch(
//   'AJ7R4UR3WT',
//   '0e9b115626f8ac0ffb933dfbb9c6dba9'
// );
//live
export const searchClient = algoliasearch(
  '3EK1SCDR61',
  '8363e291e9f413c85b577ca215f3a2a5'
);

// console.log(searchClient);